<template>
  <div style="height:100%;">
    <com-table></com-table>
  </div>
</template>
<script>
  import ComTable from "@/components/PeriodTask/Table";
  export default {
    components: {
      ComTable
    },
    data() {
      return {};
    },
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PeriodTask.vue